import { useQuery } from '@tanstack/react-query';

import { GatewayPricingPlan } from 'src/features/gateway/utils/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/gateway-pricing-plan/`;

type QueryFnType = typeof queryFn;
interface DTO extends ListDTO {
    parkingId: string;
}

const queryFn = ({ parkingId, ...params}: DTO): Promise<ListResponseSmartParkAPI<GatewayPricingPlan>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_GATEWAY_PRICING_PLANS_RESOURCE, useQueryHook as useListGatewayPricingPlans };
